import React, { useEffect, useState, useRef } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../styles/doctors.css";
import "../styles/common.css";

const doctors = [
  {
    image: "/images/doctors/doctor1.webp",
    name: "Dr. Tóth Vilmos",
    description:
      "Fog és szájbetegségek szakorvosa. A rendelőben az általános fogászat és implantáció szakmai vezetője, több mint 30 év tapasztalattal rendelkezik az általános fogászat minden területén.",
  },
  {
    image: "/images/doctors/doctor3.webp",
    name: "Dr. Losonczi Réka",
    description:
      "Fogszabályozó szakorvos. A rendelőben a fogszabályozás szakmai vezetője, kizárólag fogszabályozással foglalkozik már több mint 25 éve.",
  },
  {
    image: "/images/doctors/doctor1.webp",
    name: "Dr. Jánosi Csaba",
    description:
      "Az általános fogászat minden területén jártas, fő érdeklődési területe az endodoncia, valamint a fogpótlás.",
  },
  {
    image: "/images/doctors/doctor1.webp",
    name: "Dr. Tóth Máté",
    description:
      "Általános fogorvos, fogszabályozó rezidens. Általános fogászati beavatkozásokat és fogszabályozó kezeléseket végez rendelőnkben.",
  },
  {
    image: "/images/doctors/dental.webp",
    name: "Vrazsovits Réka",
    description:
      "Dentálhigiénikus, aki professzionális szájhigiénés kezelésekkel segíti a páciensek fogainak és ínyének egészségét.",
  },
  {
    image: "/images/doctors/assistant.webp",
    name: "Kiss Letícia",
    description:
      "Fogászati asszisztens, aki a kezelések során a gördülékeny munkavégzést és a páciensek komfortérzetét támogatja.",
  },
  {
    image: "/images/doctors/assistant.webp",
    name: "Tóth Márta",
    description:
      "Tapasztalt fogászati asszisztens, aki precízen támogatja az orvosok munkáját és kiemelt figyelmet fordít a higiéniai előírásokra.",
  },
  {
    image: "/images/doctors/assistant.webp",
    name: "Kovács Blanka",
    description:
      "Fogászati asszisztens, empatikus hozzáállással és páciensközpontú szemlélettel.",
  },
  {
    image: "/images/doctors/coordinator.webp",
    name: "Serbán Enikő",
    description:
      "Pácienskoordinátor, aki a bejelentkezések, időpontok és adminisztratív ügyek gördülékeny intézéséért felel.",
  },
];

const Doctors = () => {
  const [current, setCurrent] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  /* AOS init */
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  /* Visibility observer */
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.4 },
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);

  /* Auto slider – csak ha látható */
  useEffect(() => {
    if (!isVisible) return;

    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % doctors.length);
    }, 8000); // ✅ 2 mp

    return () => clearInterval(interval);
  }, [isVisible]);

  const handlePrev = () => {
    setCurrent((prev) => (prev - 1 + doctors.length) % doctors.length);
  };

  const handleNext = () => {
    setCurrent((prev) => (prev + 1) % doctors.length);
  };

  return (
    <section className="doctors-section" id="doctors" ref={sectionRef}>
      <div className="container">
        <div className="row align-items-center pb-5">
          {/* LEFT – Slider */}
          <div className="col-md-6 order-2 order-md-1" data-aos="zoom-in">
            <div className="doctor-carousel-wrapper">
              <button
                className="carousel-arrow left"
                onClick={handlePrev}
                aria-label="Előző"
              >
                ❮
              </button>

              <img
                src={doctors[current].image}
                alt={doctors[current].name}
                className="doctor-image"
              />

              <div className="doctor-details mt-3 text-center">
                <h4 className="doctor-name">{doctors[current].name}</h4>
                <p className="doctor-description">
                  {doctors[current].description}
                </p>
              </div>

              <button
                className="carousel-arrow right"
                onClick={handleNext}
                aria-label="Következő"
              >
                ❯
              </button>
            </div>
          </div>

          {/* RIGHT – Static text */}
          <div className="col-md-6 order-1 order-md-2" data-aos="fade-left">
            <div className="doctor-info-box">
              <h2 className="modern-title">Ismerd meg munkatársainkat</h2>
              <div className="orange-divider" />
              <p className="modern-description">
                Fogászatunk legfontosabb értéke a szakértelem és az emberi
                odafigyelés. Csapatunk minden tagja elkötelezett a páciensek
                biztonsága, kényelme és elégedettsége mellett.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Doctors;
